<script>
import Header from "./header.svelte"
import ResponsiveTable from '../utils/responsivetable3.svelte';
import {link, location, push, pop, replace} from 'svelte-spa-router';

    let table_header_config = [
        {'t': 'Date', 'fm': 'd', 'a': true},
        {'t': 'Giver', 'fm': 'g', 'a': true},
        {'t': 'Recipient', 'fm': 'r', 'a': true},
        {'t': 'Value', 'fm': 'v', 'a': true},
        {'t': 'Coupon', 'fm': 'c', 'a': true},
    ];

    let action_items = [
        {"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => {push("#/GiftCard_Review?gcid=" + id); }},
        // {"id": "edit", "i": "fas fa-edit", "s": "color: #ff9800;", "f": (id) => {push("#/GiftCard_Edit?gcid=" + id); }},
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {console.log(`whould be deleting id: ${id}`);}},
    ]
    


    let DELETE_ME_GIFTCARDS = [
        {"id": "1234501", "d": "01-01-2021", "g": "gift<br/>admin@houseofyards.com", "r": "gift recieve<br/>admin@houseofyards.com", "v": "$5.00", "c": "GIFT-DZZZNJGDSFEHVMT"},
        {"id": "1234502", "d": "01-01-2021", "g": "gift send 1<br/>giftsend1@houseofyards.com", "r": "gift get one<br/>giftget1@houseofyards.com", "v": "$200.00", "c": "GIFT-CERXMHNLVJLPXFI"},
        {"id": "1234503", "d": "09-17-2021", "g": "Monet<br/>monet@mailinator.com", "r": "Pablo Picasso<br/>pablopicasso@mailinator.com", "v": "$50.00", "c": ""},
        {"id": "1234504", "d": "09-17-2021", "g": "Monet<br/>monet@mailinator.com", "r": "Pablo Picasso<br/>pablopicasso@mailinator.com", "v": "$50.00", "c": ""},
        {"id": "1234505", "d": "09-17-2021", "g": "Van Gogh<br/>vangogh@mailinator.com", "r": "Pablo Picasso<br/>pablopicasso@mailinator.com", "v": "$20.00", "c": ""},
    ];

    function createNewGiftCard() {
        push("#/GiftCard_Create");
    }

    let date_value = "";

</script>
<Header title="Gift Cards" />

<div class="contentholder">
    <!-- <div class="buttonholder">
        <button on:click={() => {createNewGiftCard();}}><i class="fas fa-user-tag"></i> New Gift Card</button>
    </div> -->

    <div class="giftcardstableholder">
        <ResponsiveTable 
        bind:table_header_config={table_header_config} 
        table_data={DELETE_ME_GIFTCARDS} 
        num_per_page={100}             
        show_date_range={true}
        bind:date_value={date_value}
        bind:total_items={DELETE_ME_GIFTCARDS.length} 
        bind:action_items={action_items}
        />
    </div>
    
</div>



<style>

.buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        background-color: #357a38;
        color: white;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
    }

</style>